import { useParams } from "react-router-dom";
import InvestigateTimeline from "@/components/InvestigateTimeline";

// Investigate for the independent professional (docs/INVESTIGATE_PLAN.md part 3): exactly what their founder sees of
// one of their sessions.
export default function Timeline() {
  const { id } = useParams();
  return <InvestigateTimeline sid={id} audience="coder" back={{ to: "/team", label: "My sessions" }} />;
}
